import React from "react";
import {
  Typography,
  List,
  ListItemText,
  Collapse,
  ListItemButton,
} from "@mui/material";
import clsx from "clsx";
import { ComponentTemplateBriefDto } from "@growth-machine-llc/stridist-api-client";

import { ReactComponent as CaretDownIcon } from "../../icons/caret-down.svg";
import { SkeletonList } from "./ComponentTemplateLibrary";

interface TemplatesCategoryListProps {
  title: string;
  templates: ComponentTemplateBriefDto[];
  categories: string[];
  getCategoryValue: (template: ComponentTemplateBriefDto) => string;
  getCategoryDisplayName?: (categoryId: string) => string;
  isLoading: boolean;
  emptyMessage: string;
  expanded: string[];
  onCategoryClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  onTemplateClick: (event: React.MouseEvent<HTMLDivElement>) => void;
  classes: {
    title: string;
    category: string;
    caret: string;
    caretOpen: string;
    text: string;
    template: string;
    templateInCategory: string;
  };
}

export const TemplatesCategoryList: React.FC<TemplatesCategoryListProps> = ({
  title,
  templates,
  categories,
  getCategoryValue,
  getCategoryDisplayName,
  isLoading,
  emptyMessage,
  expanded,
  onCategoryClick,
  onTemplateClick,
  classes: s,
}) => {
  return (
    <>
      <Typography className={s.title} variant="subtitle1">
        {title}
      </Typography>

      {isLoading ? (
        <SkeletonList />
      ) : templates?.length > 0 ? (
        <List component="nav">
          {categories.map((category: string) => {
            const open = expanded.includes(category);
            const text = getCategoryDisplayName
              ? getCategoryDisplayName(category)
              : category;
            return (
              <React.Fragment key={category}>
                <ListItemButton
                  className={s.category}
                  onClick={onCategoryClick}
                  data-category={category}
                >
                  <CaretDownIcon
                    className={clsx(s.caret, open && s.caretOpen)}
                  />
                  <ListItemText classes={{ primary: s.text }} primary={text} />
                </ListItemButton>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {templates
                      .filter((it) => getCategoryValue(it) === category)
                      .map(({ id, title }) => (
                        <ListItemButton
                          className={clsx(s.template, s.templateInCategory)}
                          key={id}
                          onClick={onTemplateClick}
                          data-template-id={id}
                        >
                          <ListItemText
                            classes={{ primary: s.text }}
                            primary={title}
                          />
                        </ListItemButton>
                      ))}
                  </List>
                </Collapse>
              </React.Fragment>
            );
          })}
        </List>
      ) : (
        <Typography variant="body2">{emptyMessage}</Typography>
      )}
    </>
  );
};
